import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { MetaInformation } from './HeroStageOverlay.styles';
import { Colors } from '../../../../play-core/styles/Colors';
import { getDuration } from '../../utils/duration-formatter';
import { VideoProgress } from '../Teaser/TeaserActions/VideoProgress';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const WatchProgress = ({
  progress,
  duration: durationInMs
}) => {
  const {
    t
  } = useTranslation();
  const {
    duration,
    unit
  } = getDuration(durationInMs);
  const progressDuration = Math.round(progress / 100 * duration);
  const timeUnitProgressKey = unit === 'minutes' ? 'global.minutesProgress' : 'global.secondsProgress';
  return /*#__PURE__*/_jsxs(Progress, {
    children: [/*#__PURE__*/_jsx(StyledVideoProgress, {
      percentage: progress
    }), /*#__PURE__*/_jsx(MetaInformation, {
      children: t(timeUnitProgressKey, {
        progress: progressDuration,
        total: duration
      })
    })]
  });
};
const Progress = styled.div.withConfig({
  displayName: "WatchProgress__Progress",
  componentId: "sc-txwctk-0"
})(["display:flex;align-items:center;flex-direction:row;gap:12px;width:100%;"]);
const StyledVideoProgress = styled(VideoProgress).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "WatchProgress__StyledVideoProgress",
  componentId: "sc-txwctk-1"
})(["height:8px;border-radius:8px;background-color:", ";max-width:220px;width:100%;"], Colors.GREY_4a4a4a);